import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {UserService} from '../service/user.service';

@Directive({
  selector: '[userRole]'
})
export class RolePermissionsDirective implements OnInit {

  private currentUser;

  @Input() userRole;

  constructor(private elRef: ElementRef,
              private userService: UserService) {

    this.elRef.nativeElement.style.display = 'none';
  }

  ngOnInit() {
    const roles = this.userRole.split(',');
    this.currentUser = this.userService.currentUserSubject.getValue();
    let displayType = 'block';

    switch (this.elRef.nativeElement.localName) {
      case 'td':
      case 'th':
        displayType = 'table-cell';
        break;
      case 'span':
        displayType = 'inline-block';
      default:
        break;
    }
    for (let i = 0; roles.length > i; i += 1) {
      // superadmin
      if (this.currentUser.role === 'superadmin' && roles[i] === 'superadmin') {
        this.elRef.nativeElement.style.display = displayType;
      }
      // admin
      if (this.currentUser.role === 'admin' && roles[i] === 'admin') {
        this.elRef.nativeElement.style.display = displayType;
      }
      // user
      if (this.currentUser.role === 'user' && (roles[i] === 'user' || roles[i] === '')) {
        this.elRef.nativeElement.style.display = displayType;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/role-permissions.directive.ts